/* Mimi Shape size finder (copy v7 §2). Needs mimi-size.js.
   Mimi.openFinder({ opener, chart, product, onSelect(size) }) — every entry point calls this:
   the size links, "למצוא את המידה שלי", the size chart window, the sticky bar with no size,
   "לשנות מידה" in the cart, and the home buttons (data-m-finder-product="handle"). */
(() => {
  const Mimi = (window.Mimi = window.Mimi || {});
  const dlg = document.querySelector('[data-m-finder]');
  if (!dlg) return;
  const $ = (s, r = dlg) => r.querySelector(s);
  const $$ = (s, r = dlg) => [...r.querySelectorAll(s)];
  const data = JSON.parse($('[data-m-finder-json]').textContent);

  const result = $('[data-step="result"]');
  const measure = Object.fromEntries($$('[data-step="measure"]').map((s) => [s.dataset.key, s]));
  const back = $('[data-m-finder-back]');

  let ctx = {};
  let order = ['waist', 'hips'];
  let values = {};
  let at = 0; // index into order | 'result'

  const bdi = (text) => { const b = document.createElement('bdi'); b.dir = 'ltr'; b.textContent = text; return b; };
  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; };

  // The dialog's name is the question (or result line) on screen; focus goes there too
  const show = (step, heading) => {
    [result, ...Object.values(measure)].forEach((s) => { s.hidden = s !== step; });
    back.hidden = step === measure[order[0]];
    if (heading) dlg.setAttribute('aria-labelledby', heading.id);
    step.scrollTop = 0; dlg.scrollTop = 0;
    heading?.focus({ preventScroll: true });
  };

  const progress = (step, filled) => {
    const bar = $('[data-m-finder-prog]', step);
    bar.replaceChildren(...order.map((_, i) => el('i', i < filled ? 'is-on' : '')));
  };

  const goMeasure = (i) => {
    at = i;
    const key = order[i];
    const step = measure[key];
    progress(step, i + 1);
    const input = $('[data-m-finder-input]', step);
    if (values[key] && !input.value) input.value = values[key];
    show(step, $('h2', step));
  };

  const next = () => {
    const key = order[at];
    const input = $('[data-m-finder-input]', measure[key]);
    const v = input.value.trim();
    if (!v || Number.isNaN(Number(v))) { input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
    input.removeAttribute('aria-invalid');
    values[key] = Number(v);
    if (at < order.length - 1) { goMeasure(at + 1); return; }
    // Only measurements in the valid range are kept for the product page and the cart
    const keep = Object.fromEntries(order.filter((k) => Mimi.validateMeasurement(k, values[k]) === 'ok').map((k) => [k, values[k]]));
    Mimi.measurements.save({ ...(Mimi.measurements.get() || {}), ...keep });
    goResult();
  };

  const goResult = () => {
    at = 'result';
    progress(result, order.length);
    const found = $('[data-m-finder-found]', result);
    const outside = $('[data-m-finder-outside]', result);
    const choices = $('[data-m-finder-choices]', result);
    choices.replaceChildren();
    const size = Mimi.recommendSize(ctx.chart, values);
    found.hidden = !size;
    outside.hidden = !!size;
    if (size) {
      $('[data-m-finder-size]', result).replaceChildren(bdi(size));
      if (ctx.onSelect) {
        const b = el('button', 'm-btn', data.choose);
        b.type = 'button';
        b.addEventListener('click', () => { const cb = ctx.onSelect; close(); cb(size); });
        choices.append(b);
      }
    }
    show(result, size ? $('#FinderResult', result) : outside);
  };

  const close = () => { if (dlg.open) dlg.close(); };

  // Outside a product page: the product the button names, else the first one the finder knows
  const productFor = (handle) => data.products.find((p) => p.handle === handle) || data.products[0] || null;

  Mimi.openFinder = (detail = {}) => {
    const page = Mimi.product;
    const other = !page || detail.product ? productFor(detail.product) : null;
    ctx = {
      opener: detail.opener || document.activeElement,
      chart: detail.chart !== undefined ? detail.chart : page && !other ? page.chart : other ? other.chart : null,
      onSelect: detail.onSelect !== undefined ? detail.onSelect
        : page && !other ? (size) => {
          if (Mimi.selectSize) Mimi.selectSize(size, true);
          document.querySelector('[data-m-main-button]')?.focus();
        }
        // Home: go to the product; its page picks her size from the saved measurements
        : other ? () => { window.location.href = other.url; } : null,
    };
    const chart = Mimi.parseChart(ctx.chart);
    order = chart ? chart.measurements.filter((k) => measure[k]) : ['waist', 'hips'];
    values = { ...(Mimi.measurements.get() || {}) };
    $$('[data-m-finder-input]').forEach((i) => { i.value = values[i.name] || ''; i.removeAttribute('aria-invalid'); });
    document.documentElement.classList.add('m-finder-open');
    dlg.showModal();
    goMeasure(0);
  };

  /* Any [data-m-open-finder] on any page */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-m-open-finder]');
    if (!btn) return;
    e.preventDefault();
    const product = btn.dataset.mFinderProduct;
    if (!product && typeof Mimi.requestFinder === 'function') Mimi.requestFinder({ opener: btn });
    else Mimi.openFinder({ opener: btn, product });
  });

  /* Events */
  $$('[data-m-finder-next]').forEach((b) => b.addEventListener('click', next));
  $$('[data-m-finder-input]').forEach((i) => {
    i.addEventListener('input', () => {
      const clean = i.value.replace(/[^\d]/g, '');
      if (clean !== i.value) i.value = clean;
      i.removeAttribute('aria-invalid');
    });
    i.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); next(); } });
  });
  back.addEventListener('click', () => {
    if (at === 'result') goMeasure(order.length - 1);
    else if (at > 0) goMeasure(at - 1);
  });
  $('[data-m-finder-close]').addEventListener('click', close);
  // Desktop: a click on the backdrop closes
  dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
  dlg.addEventListener('close', () => {
    document.documentElement.classList.remove('m-finder-open');
    if (ctx.opener && document.contains(ctx.opener) && document.activeElement === document.body) ctx.opener.focus();
  });
})();
